// Episode groups used outside the episode selectors. Kept here, without the selectors: the reducer of the ice player
// is part of the root store, and importing the selectors for one id pulled the whole video player into the main chunk.
// The values equal the types the selectors build (episode-group-ids.test.js checks it).

/** All the shot attempts of the game (selectors/private/game-shots.js) */
export const GAME_SCORE_ATTEMPTS = 'GAME_SCORE_ATTEMPTS';
